export default __webpack_public_path__ + "static/media/highlight.21fd895d.svg";